import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default:
                    "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
                secondary:
                    "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
                destructive:
                    "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
                outline: "text-foreground",
                // Status variants
                todo: "border-transparent bg-gray-500/20 text-gray-400",
                inProgress: "border-transparent bg-blue-500/20 text-blue-400",
                inReview: "border-transparent bg-amber-500/20 text-amber-400",
                done: "border-transparent bg-green-500/20 text-green-400",
                cancelled: "border-transparent bg-red-500/20 text-red-400",
                // Priority variants
                none: "border-transparent bg-gray-500/10 text-gray-500",
                low: "border-transparent bg-slate-500/20 text-slate-400",
                medium: "border-transparent bg-yellow-500/20 text-yellow-400",
                high: "border-transparent bg-orange-500/20 text-orange-400",
                urgent: "border-transparent bg-red-500/20 text-red-400",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    )
}

export { Badge, badgeVariants }
